var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompareBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.25C4.5 8.83579 4.83579 8.5 5.25 8.5H16.75C17.1642 8.5 17.5 8.83579 17.5 9.25V14.75C17.5 15.1642 17.1642 15.5 16.75 15.5H5.25C4.83579 15.5 4.5 15.1642 4.5 14.75V9.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C2.34315 5 1 6.34315 1 8V16C1 17.6569 2.34315 19 4 19H18C19.6569 19 21 17.6569 21 16V15H22C22.5523 15 23 14.5523 23 14V10C23 9.44772 22.5523 9 22 9H21V8C21 6.34315 19.6569 5 18 5H4ZM18 7H4C3.44772 7 3 7.44772 3 8V16C3 16.5523 3.44772 17 4 17H18C18.5523 17 19 16.5523 19 16V8C19 7.44771 18.5523 7 18 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareBattery);
export default __webpack_public_path__ + "static/media/compare_battery.0cff4dac2bb84dee161d61012e03731d.svg";
export { ForwardRef as ReactComponent };